import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "enable-background": "new 0 0 45 45",
  height: "45",
  viewBox: "0 0 45 45",
  width: "45",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m-1185.47 114.46c-1.06-.02-2.06-.42-2.82-1.13l-1.41-1.24c-.35-.32-.77-.49-1.21-.5h-8.67v-2h8.69c.95.02 1.84.38 2.53 1.01l1.41 1.23c.43.39.95.6 1.51.61h6.33c.55-.01 1.1-.24 1.51-.64l1.28-1.17c.67-.65 1.59-1.03 2.55-1.05h9.19v2h-9.17c-.44.01-.87.19-1.21.51l-1.28 1.17c-.75.73-1.78 1.16-2.86 1.18h-6.37z",
      transform: "translate(1204.587 -89.525)"
    }, null, -1)
  ])))
}
export default { render: render }